<template>
  <div>
    <span v-if="days">{{ days }}:</span>
    <span v-if="hours">{{ hours | formatTime }}:</span>
    <span>{{ minutes | formatTime }}:{{ seconds | formatTime }}</span>
  </div>
</template>

<script>
export default {
  props: ['time', 'date'],
  data() {
    return {
      currentTime: null,
      elapsedTime: 0
    }
  },  
  computed: {
    deadline() {
      if (this.time) {
        return Date.parse(new Date()) + this.time * 1000
      }

      if (this.date) {
        return Date.parse(this.date)
      }
    },
    elapsedTimeData() {
      let elapsed = this.elapsedTime * 1000

      return {
        days: Math.floor(elapsed / (1000 * 60 * 60 * 24)),
        hours: Math.floor((elapsed / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((elapsed / 1000 / 60) % 60),
        seconds: Math.floor((elapsed / 1000) % 60),
        total_ms: elapsed
      }
    },
    seconds() {
      return Math.floor((this.currentTime / 1000) % 60);
    },
    minutes() {
      return Math.floor((this.currentTime / 1000 / 60) % 60);
    },
    hours() {
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24);
    },
    days() {
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24));
    }
  },
  filters: {
    formatTime(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    }
  },
  methods: {
    countdown() { 
      this.elapsedTime++     
      this.currentTime = this.deadline - Date.parse(new Date());
      if (this.currentTime > 0) {        
        setTimeout(this.countdown, 1000);        
      } else {
        this.currentTime = null;
        this.$emit('stop', this.elapsedTimeData)
      }
    },
    start() {
      if (this.deadline) {
        this.currentTime = this.deadline - Date.parse(new Date());
        setTimeout(this.countdown, 1000); 
      } else {
        setInterval(() => {
          this.elapsedTime++
          this.currentTime = this.elapsedTime * 1000
        }, 1000);
      }
      
    }
  }
}
</script>